module.exports = __webpack_public_path__ + "static/media/oberflex-aniegret461-1200x2490.277c853e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-aniegret461-1200x2490.jpg
// module id = 978
// module chunks = 37